module.exports = __webpack_public_path__ + "img/logo_insta_verde.15cf7c8a.svg";